import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Pagination from 'react-bootstrap/Pagination';

import { IoEyeOutline } from "react-icons/io5";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { useNavigate, Link } from "react-router-dom";

import { FaGoogle } from "react-icons/fa";

import Card from 'react-bootstrap/Card';

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';


let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

const LoginPage =({login, loggedIn}) => {    
    const navigate = useNavigate();
	const [formData, setFormData] = useState({
        email: "",
		password: ""
    });
	
    const [ errors, setErrors ] = useState({});
    const [showPass, setShowPass] = useState(false);
	const [passwordType, setPasswordType] = useState('password');

    useEffect(() => {
		if(loggedIn){
			window.location.href = '/';
		}
	},[loggedIn]);
	
    
    const showPassword = () => {
		if(!showPass){
		  setPasswordType('text');
		} else {
		  setPasswordType('password');
		}
		setShowPass(!showPass);
	}

	const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }

    const findFormErrors = () => {
        const { email, password } = formData
        let newErrors = {}

        
        // password errors
        if ( !email || email === '' ) newErrors.email = 'Enter email address'
        if ( !password || password === '' ) newErrors.mobile = 'Enter password'
        
        
        if(email && !validateEmail(email)){
            newErrors.email = 'Your e-mail has been entered in the wrong format. Please check and try again';
          }
        // console.log('newErrors', newErrors)
        setErrors(newErrors);
        return newErrors
    }

    const handleChange = (e) => { 
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });  
        findFormErrors();
    }

	const handleSubmit = async(event) => { 
		
		const checkErrors = findFormErrors();
		
		const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        // console.log('check 2', Object.keys(checkErrors).length)
        if ( Object.keys(checkErrors).length > 0 ) {
            setErrors(checkErrors);
        } else {
            // Auth
            await login(formData).then(res => { 
                if(res.payload.data && res.payload.data.token){
                    localStorage.setItem('user', res.payload.data.token);
					window.location.href = '/';
                }
            })
		}
	}

    return (
        <div>
            <Header/>
            <section className='pt-5 pb-5 bg-dark'>
                <h3 className='text-center'>Sign In</h3>
            </section>
            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col xs={6}>
                            <Card className='shadow p-4'>
                                <Card.Body>
                                    <h2 className='text-center'>Sign In</h2>
                                    <Button className='d-block w-100' variant='light'> <FaGoogle /> Sign in with google</Button>
                                    <form className='mt-4' noValidate onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3" controlId="formGroupEmail">
                                            <Form.Control type="email" placeholder="Email address" name="email" onChange={handleChange} className={ errors.email ? "input-error mb-3" : "mb-3"}  />
                                            {
                                                errors.email ? 
                                                <Form.Control.Feedback>
                                                    { errors.email }
                                                </Form.Control.Feedback>
                                                : ''
                                            }
                                        </Form.Group>
                                        
                                        <InputGroup className="mb-3">
                                            <Form.Control
                                                placeholder="Password"
                                                type={passwordType}
                                                onChange={handleChange}
                                                className={ errors.password ? "input-error mb-3" : "mb-3"} 
                                                name="password"
                                            />
                                            <Button variant="outline-secondary" id="button-addon2">
                                                <IoEyeOutline />
                                            </Button>
                                        </InputGroup>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                                    <Form.Check type="checkbox" label="Keep me logged" />
                                                </Form.Group>
                                            </Col>
                                            <Col className='text-end'><Link to={`/forget-password`}>Forget password</Link></Col>
                                        </Row>
                                        <Button type="submit" className='d-block w-100 btn-lg mt-3'>Sign in</Button>
                                        <div className='text-center mt-4'>Don’t have account? <Link to={`/signup`}>Sign Up</Link></div>
                                    </form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    // console.log(state.customer)
    return {
        customerAccessToken: state.customer.customerAccessToken,
        loggedIn: state.customer.loggedIn
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        login: (post) => dispatch(actions.signIn(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);